import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { trackPageView } from "../lib/analytics";

// Fires a first-party page_view on every route change (client-side).
// Runs alongside the Meta Pixel PageViewTracker.
export default function AnalyticsTracker() {
  const { pathname, search } = useLocation();
  useEffect(() => {
    trackPageView();
  }, [pathname, search]);
  return null;
}
